module.exports = __webpack_public_path__ + "img/account.9408f1ea.svg";